import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
import del from '../img/delete.svg';
import plus from '../img/plus.svg';
var ReactSuperSelect = require('react-super-select')


class Holidays extends Component {
	constructor(props) {
		super(props);
		this.state = {
			addingHoliday: false,
			editingHoliday: false,
			deletingHoliday: false,
			loading: false,
			filterBy: {},
			sortBy: 'role',
			sortOrder: 1
		};

	}
	cancel = () => {
		this.setState({ addingHoliday: false, editingHoliday: false, deletingHoliday: false, loading: false, name: false, date: false, active: null })
	}
	editHolidayName = (e) => {
		if (e.target.value < 1) {
			this.setState({ name: '', error: 'Please enter a holiday name.' });
		} else {
			this.setState({ name: e.target.value, error: '' });
		}
	}
	editHoliday = (holiday) => e => {
		this.setState({ editingHoliday: true, loading: false, id: holiday.Id, name: holiday.Holiday_Name, date: holiday.Holiday_Date, active: holiday.is_enabled, error: '' })
	}
	confirmEditHoliday = () => {
		if (this.state.name.length < 1) {
			this.setState({ error: 'Please enter a holiday name.' });
		} else if (!this.state.date) {
			this.setState({ error: 'Please select a date for this holiday.' });
		} else {
			this.setState({ loading: true });
			this.props.ws.send(JSON.stringify({ route: 'editHoliday', name: this.state.name, date: this.state.date, id: this.state.id, active: this.state.active }))
		}
	}

	addHoliday = (e) => {
		this.setState({ addingHoliday: true, loading: false, name: '', date: '', error: '', active: false })
	}
	confirmAddHoliday = () => {
		if (this.state.name.length < 1) {
			this.setState({ error: 'Please enter a holiday name.' });
		} else if (!this.state.date) {
			this.setState({ error: 'Please select a date for this holiday.' });
		} else {
			this.setState({ loading: true });
			this.props.ws.send(JSON.stringify({ route: 'addHoliday', name: this.state.name, date: this.state.date, active: this.state.active }))
		}
	}

	deleteHoliday = (holiday) => e => {
		e.stopPropagation()
		this.setState({ deletingHoliday: true, loading: false, name: holiday.Holiday_Name, error: '' })
	}
	confirmDeleteHoliday = () => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'deleteHoliday', name: this.state.name }))
	}

	checkEnter = (e) => {
		if (e.keyCode === 13) {
			if (this.state.addingHoliday) {
				this.confirmAddHoliday();
			} else if (this.state.editingHoliday) {
				this.confirmEditHoliday();
			} else if (this.state.deletingHoliday) {
				this.confirmDeleteHoliday();
			}
		}
	}

	toggle = (param) => (e) => {
		var newState = Object.assign({}, this.state)
		newState[param] = this.state[param] ? false : true
		this.setState(newState)
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel()
		}
	}


	sort = (sortBy) => (e) => {
		var sortOrder
		if (this.state.sortOrder === -1) {
			sortOrder = 1;
		} else {
			sortOrder = -1;
		}
		this.setState({ sortBy: sortBy, sortOrder: sortOrder })
	}

	filter = (field) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[field] = e.target.value
		} else {
			delete filterBy[field]
		}
		this.setState({ filterBy: filterBy })
	}

	sortFunc(sortBy, sortOrder) {
		return function (a, b) {

			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.Holiday_Date > b.Holiday_Date ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			}
		}
	}

	filterFunc(array, filterBy) {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (typeof object[prop] === "undefined") {
					return false
				}
				if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true
		})
	}

	filterByDropdown = (value) => {
		var filterBy = this.state.filterBy
		if (!value) {
			delete filterBy.is_enabled
		} else if (value.id == 1) {
			filterBy.is_enabled = true
		} else if (value.id == 0) {
			filterBy.is_enabled = false
		}
		this.setState({ filterBy: filterBy })

	}




	render() {
		if (this.props.active) {


			var holidayList = []
			var holidays = JSON.parse(JSON.stringify(this.props.data.Holidays));

			//Filtering User List
			if (Object.keys(this.state.filterBy).length > 0) {
				holidays = this.filterFunc(holidays, this.state.filterBy)
			}

			//Sorting filtered User List
			if (this.state.sortBy !== '') {
				holidays.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}


			for (var holiday of holidays) {
				holidayList.push(
					<div className="dataRow" key={holiday.Id} onClick={this.editHoliday(holiday)}>
						<div className="activeBox">
							<div className={holiday.is_enabled ? "enabled" : "disabled"}></div>
						</div>
						<span style={{ flex: '1 0 300px' }} >{holiday.Holiday_Name}</span>
						<span style={{ flex: '0 0 300px', textAlign: 'right' }} >{new Date(holiday.Holiday_Date).toDateString()}</span>
						<span className="buttonBox" style={{ flex: '0 0 65px' }}>
							<img src={del} alt="Delete Holiday" onClick={this.deleteHoliday(holiday)} />
						</span>
					</div>
				)
			}


			var editHoliday = ""
			if (this.state.editingHoliday) {
				editHoliday = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.name} onChange={this.editHolidayName} ></input>
								<span className="inputBar"></span><label className="textLabel">Holiday Name</label>
							</div>

							<div style={{ display: 'inline-block' }}>
								<div>Holiday Date</div>
								<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "Y-m-d" }} value={this.state.date} onChange={date => { date[0] ? this.setState({ date: date[0] }) : this.setState({ date: undefined }) }} />
							</div>

							<div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
								<div >
									<div>Active</div>
									<div className="activeBox" onClick={this.toggle('active')}>
										<div className={this.state.active ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>
							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmEditHoliday}>Confirm Holiday</div>}
						</div>
					</div>
				)
			}

			var addHoliday = ""
			if (this.state.addingHoliday) {
				addHoliday = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.name} onChange={this.editHolidayName} ></input>
								<span className="inputBar"></span><label className="textLabel">Holiday Name</label>
							</div>

							<div style={{ display: 'inline-block' }}>
								<div>Holiday Date</div>
								<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "Y-m-d" }} value={this.state.date} onChange={date => { date[0] ? this.setState({ date: date[0] }) : this.setState({ date: undefined }) }} />
							</div>

							<div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
								<div >
									<div>Active</div>
									<div className="activeBox" onClick={this.toggle('active')}>
										<div className={this.state.active ? "enabled" : "disabled"}></div>
									</div>
								</div>
							</div>

							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmAddHoliday}>Confirm New Holiday</div>}
						</div>
					</div>
				)
			}

			var deleteHoliday = ""
			if (this.state.deletingHoliday) {
				deleteHoliday = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>
							<div>You Are Removing Holiday</div>
							<div style={{ margin: "15px" }}> {this.state.name} </div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDeleteHoliday}>Delete This Holiday</div>}
						</div>
					</div>
				)
			}

			return (
				<div width="100%">
					<img src={plus} className="plusButton" alt="Add a Holiday" onClick={this.addHoliday} />
					<div className="dataHeaders">
						<span style={{ flex: '0 0 83px', cursor: 'pointer', textAlign: 'center' }} onClick={this.sort("is_enabled")}>Active?</span>
						<span style={{ flex: '1 0 300px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("Holiday_Name")}>Description</span>
						<span style={{ flex: '0 0 300px', cursor: 'pointer' }} onClick={this.sort("Holiday_Date")}>Date</span>
					</div>
					<div className="dataFilters">
						<ReactSuperSelect clearable={false} style={{ flex: '0 0 90px', margin: '0px' }} customClass="r-ss-active" placeholder="   " dataSource={[{ id: 1, name: 'Active' }, { id: 0, name: 'Inactive' }]} onChange={this.filterByDropdown} />
						<input style={{ flex: '1 0 300px' }} type="text" onChange={this.filter("Holiday_Name")} value={this.state.filterBy.Holiday_Name} />
						<input style={{ flex: '0 0 300px' }} type="text" onChange={this.filter("Holiday_Date")} value={this.state.filterBy.Holiday_Date} />
					</div>
					<div style={{ overflow: 'auto', height: 'calc(100% - 85px)' }}>
						{holidayList}
					</div>

					{editHoliday}
					{addHoliday}
					{deleteHoliday}

				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}


const icon = "menuCalendar"
const roles = ["View"]
export { Holidays, icon, roles }